import React, { useState } from 'react';
import DataService from '../../services/data.service';
import LoaderOverlay from '../common/loader.component';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';

const AddBookingQuestion = () => {
  const [question, setQuestion] = useState('');
  const [inputType, setInputType] = useState('text');
  const [isRequired, setIsRequired] = useState(false);
  const [options, setOptions] = useState(['']);
  const [displayOrder, setDisplayOrder] = useState(0);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleAddOption = () => {
    setOptions([...options, '']);
  };

  const handleRemoveOption = (index) => {
    const newOptions = options.filter((_, i) => i !== index);
    setOptions(newOptions);
  };

  const handleOptionChange = (index, value) => {
    const newOptions = [...options];
    newOptions[index] = value;
    setOptions(newOptions);
  };

  const handleAddQuestion = async (e) => {
    e.preventDefault();

    if (!question.trim()) {
      setError('Question text is required.');
      return;
    }

    if (['radio', 'checkbox', 'select'].includes(inputType)) {
      const validOptions = options.filter(opt => opt.trim() !== '');
      if (validOptions.length === 0) {
        setError('At least one option is required for this input type.');
        return;
      }
    }

    setLoading(true);
    setError('');

    try {
      const payload = {
        question,
        input_type: inputType,
        is_required: isRequired ? 1 : 0,
        display_order: parseInt(displayOrder) || 0,
      };

      if (['radio', 'checkbox', 'select'].includes(inputType)) {
        payload.options = options.filter(opt => opt.trim() !== '');
      }

      await DataService.addBookingQuestion(payload);
      toast.success('Booking Question added Successfully.');
      navigate('/booking-questions');
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to add question.');
    } finally {
      setLoading(false);
    }
  };

  const showOptions = ['radio', 'checkbox', 'select'].includes(inputType);

  return (
    <>
      <LoaderOverlay loading={loading} />

      <h4>Add New Booking Question</h4>

      <form onSubmit={handleAddQuestion} className="mt-3">
        <div className="mb-3">
          <label className="form-label">Question</label>
          <input
            type="text"
            className="form-control px-3"
            placeholder="Enter question text"
            value={question}
            onChange={(e) => setQuestion(e.target.value)}
          />
        </div>

        <div className="mb-3">
          <label className="form-label">Input Type</label>
          <select
            className="form-control px-3"
            value={inputType}
            onChange={(e) => setInputType(e.target.value)}
          >
            <option value="text">Text</option>
            <option value="textarea">Textarea</option>
            <option value="radio">Radio</option>
            <option value="checkbox">Checkbox</option>
            <option value="select">Select Dropdown</option>
          </select>
        </div>

        {showOptions && (
          <div className="mb-3">
            <label className="form-label">Options</label>
            {options.map((option, index) => (
              <div key={index} className="d-flex gap-2 mb-2">
                <input
                  type="text"
                  className="form-control px-3"
                  placeholder={`Option ${index + 1}`}
                  value={option}
                  onChange={(e) => handleOptionChange(index, e.target.value)}
                />
                {options.length > 1 && (
                  <button
                    type="button"
                    className="btn btn-danger"
                    onClick={() => handleRemoveOption(index)}
                  >
                    Remove
                  </button>
                )}
              </div>
            ))}
            <button
              type="button"
              className="btn btn-secondary btn-sm"
              onClick={handleAddOption}
            >
              + Add Option
            </button>
          </div>
        )}

        <div className="mb-3 form-check">
          <input
            type="checkbox"
            className="form-check-input"
            id="isRequired"
            checked={isRequired}
            onChange={(e) => setIsRequired(e.target.checked)}
          />
          <label className="form-check-label" htmlFor="isRequired">
            Required Field
          </label>
        </div>

        <div className="mb-3">
          <label className="form-label">Display Order</label>
          <input
            type="number"
            className="form-control px-3"
            placeholder="Enter display order (0 for default)"
            value={displayOrder}
            onChange={(e) => setDisplayOrder(e.target.value)}
          />
        </div>

        {error && <div className="alert alert-danger">{error}</div>}

        <button type="submit" className="btn btn-primary">
          Add Question
        </button>
        <button
          className="btn btn-outline-secondary"
          style={{ marginLeft: '15px' }}
          onClick={() => navigate(-1)}
          type="button"
        >
          ← Back
        </button>
      </form>
    </>
  );
};

export default AddBookingQuestion;